import { TEAM_TYPES } from 'common/constants/constants';
import { FILTER_TYPES, filterFormatter } from 'common/constants/filters';
import { flattenTree } from 'components/base/MultiLevelDropdown/MultiLevelDropdown.utils';
import { useSelector } from 'react-redux';
import { syncTeamsRootLevelTreeSelector } from 'state/selectors/teams';

const TEAM_TYPES_TO_FILTER = [
  TEAM_TYPES.ALL_TEAMS,
  TEAM_TYPES.ALL_CONTRIBUTORS
];

const useOrgTeams = () => {
  const orgTreeTeams = useSelector(syncTeamsRootLevelTreeSelector);
  const orgFlattenTreeTeams = flattenTree(orgTreeTeams, 'children');
  const orgTeams = filterFormatter[FILTER_TYPES.ORGANIZATION_TEAMS](
    orgFlattenTreeTeams
  ).filter(({ entity }) => !TEAM_TYPES_TO_FILTER.includes(entity?.type));
  return orgTeams;
};

export default useOrgTeams;
